"use client";

import { Link } from "@/components/ui/Link";
import { Container } from "@/components/ui/Container";
import { Reveal } from "@/components/ui/Reveal";
import { SectionLabel } from "@/components/ui/SectionLabel";
import { SplitHeading } from "@/components/ui/SplitHeading";

type CTABannerProps = {
  label?: string;
  headline: string;
  description?: string;
  ctaLabel: string;
  href: string;
};

export function CTABanner({
  label,
  headline,
  description,
  ctaLabel,
  href,
}: CTABannerProps) {
  if (!headline || !ctaLabel || !href) return null;

  return (
    <section className="py-16 md:py-24 lg:py-28">
      <Container>
        <Reveal>
          <div className="relative overflow-hidden rounded-2xl border border-white/10 bg-surface px-8 py-20 md:px-16 md:py-28">
            <div
              className="pointer-events-none absolute -right-24 -top-24 h-96 w-96 rounded-full bg-white/[0.03] blur-3xl"
              aria-hidden="true"
            />
            <div
              className="pointer-events-none absolute -bottom-32 -left-20 h-96 w-96 rounded-full bg-accent/10 blur-3xl"
              aria-hidden="true"
            />

            <div className="relative max-w-2xl">
              {label ? <SectionLabel>{label}</SectionLabel> : null}
              <SplitHeading
                italicPrimary={false}
                className="mt-6 text-5xl font-medium tracking-tight md:text-6xl"
              >
                {headline}
              </SplitHeading>
              {description ? (
                <p className="mt-6 max-w-lg text-base text-muted">
                  {description}
                </p>
              ) : null}
              <Link
                href={href}
                className="mt-10 inline-flex items-center gap-2 rounded-full bg-white px-6 py-3 text-sm font-medium text-background transition hover:bg-white/90"
              >
                {ctaLabel}
                <span aria-hidden="true">→</span>
              </Link>
            </div>
          </div>
        </Reveal>
      </Container>
    </section>
  );
}
